export enum Area {
  ADMIN_OBJECT_AREA = 'ADMIN_OBJECT_AREA',
  STUDENT_DELIVERY_AREA = 'STUDENT_DELIVERY_AREA',
  STUDENT_OBJECT_AREA = 'STUDENT_OBJECT_AREA',
  STUDENT_NOTIFICATION_AREA = 'STUDENT_NOTIFICATION_AREA',
  AUTHENTICATION = 'AUTHENTICATION'
}
